// extracted by mini-css-extract-plugin
export var fileUpload = "_h6-1";
export var modalButton = "_h6-0";